import { fCurrency, getExpenseEntry } from '../../utils'
import { Spinner } from 'components'
import { useEffect, useState } from 'react'
import { getActualsExpenseEntry } from 'utils/getActualsExpenseEntry'

const ExpenseActualsEntryCell = ({ id, month, name, trackerEntries }) => {
  const [entry, setEntry] = useState(null)

  useEffect(() => {
    getActualsExpenseEntry(id, month, name, trackerEntries).then((item) => {
      setEntry(item)
    })
  }, [trackerEntries])

  return entry == null ? (
    <td>
      <Spinner />
    </td>
  ) : entry.data == null ? (
    <td className='text-success'> - </td>
  ) : (
    <td className='text-success'>{fCurrency(entry.data.amount)}</td>
  )
}

export default ExpenseActualsEntryCell
